import { UserRole } from '@api-open';

export interface DecodedToken {
  nameid: string;
  role: UserRole;
  '2fa_pending'?: 'true' | 'false' | 'False' | 'True' | null;
}

export const decodeToken = (token: string): DecodedToken | null => {
  try {
    const [_header, payload, _sig] = token.split('.');
    const decodedPayload = atob(payload);
    return JSON.parse(decodedPayload);
  } catch (_err) {
    return null;
  }
};
